import type { AdvancedThreshold, ThresholdColor } from "@/overlay/components/CommonParts/Threshold/types";
import type { LegendItem } from "@/overlay/components/Legends/ThresholdLegend/ThresholdLegend";

export const getThresholdLegendItems = (
  thresholds: ThresholdColor[],
  unit?: string,
  advancedThresholds?: AdvancedThreshold[],
): LegendItem[] => {
  if (advancedThresholds && advancedThresholds.length > 0) {
    return advancedThresholds.map((threshold, index) => ({
      color: threshold.color,
      label: threshold.label,
      id: `legend-item-${index}`,
    }));
  }
  return thresholds.map((threshold, index) => ({
    color: threshold.color,
    label: `${threshold.condition} ${threshold.value} ${unit}`,
    id: `legend-item-${index}`,
  }));
};
